
class StudentService {

    constructor() {}

    public postStudyDataByForm =  (language: string, data: any, HttpService: any): Promise<any> => {
        return this.postStudyData(this.studyDataQuery(language), HttpService, data);
    }

    public getRegistrationConfirm =  (language: string, data: any, HttpService: any): Promise<any> => {
        return this.postStudyData(this.registrationsConfirmQuery(language), HttpService, data);
    }

    public postRequestCertifiedGrades = (vunetId: string, studyId: string, language: string, data: any, HttpService: any): Promise<any> => {
        return this.postStudyData(this.requestCertifiedGradesQuery(vunetId, studyId, language), HttpService, data);
    }

    public postStudyData = (url: string, HttpService: any, data: JSON): Promise<any> => {
        return new Promise((resolve, reject) => {
            HttpService.postRefresh(url, data).then((result: any) => {
                resolve(result);
            }).catch((error: any) => {
                if (error.response.status === 400) {
                    reject(error);
                } else {
                    reject(error);
                }
            });
        });
    }

    public studyDataQuery = (language: string): string => {
        return `/api/students/registrations?language=${language}`;
    }

    public registrationsConfirmQuery = (language: string): string => {
        return `/api/students/registrations/confirm?language=${language}`;
    }

    public requestCertifiedGradesQuery = (vuNetId: string, studyId: string, language: string): string => {
        return `/api/students/grades/certified/${vuNetId}/${studyId}/${language}`;
    }
}

export default new StudentService();



